// Reads the HTTP status from a thrown axios error (`error.response.status`).
export function httpStatus(error) {
  return error?.response?.status;
}

export function httpMessage(error) {
  return error?.response?.data?.message;
}
